// @ts-ignore
import * as Surplus from "surplus";

export function InlineSVG(props: { children?: any }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="0"
            height="0"
            style={{ display: "none" }}>
            <defs>{props.children}</defs>
        </svg>
    );
}

export function SVGMinus() {
    return (
        <g id="minus">
            <path d="M0 9h24v6h-24z" />
        </g>
    );
}

export function SVGPlus() {
    return (
        <g id="plus">
            <path d="M24 9h-9v-9h-6v9h-9v6h9v9h6v-9h9z" />
        </g>
    );
}

export function SVGMail() {
    return (
        <g id="mail">
            <path d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z" />
        </g>
    );
}

export function SVGRSSFeed() {
    return (
        <g id="rss-feed-icon">
            <path d="M6.503 20.752c0 1.794-1.456 3.248-3.251 3.248-1.796 0-3.252-1.454-3.252-3.248 0-1.794 1.456-3.248 3.252-3.248 1.795.001 3.251 1.454 3.251 3.248zm-6.503-12.572v4.811c6.05.062 10.96 4.966 11.022 11.009h4.817c-.062-8.71-7.118-15.758-15.839-15.82zm0-3.368c10.58.046 19.152 8.594 19.183 19.188h4.817c-.03-13.231-10.755-23.954-24-24v4.812z" />
        </g>
    );
}

export function SVGVertEllipsis() {
    return (
        <g id="vert-ellipsis">
            <path d="m128 256c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0" />
            <path d="m128 64c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0" />
            <path d="m128 448c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0" />
        </g>
    );
}

export const SVGForm = {
    EyeOpen: () => {
        return (
            <g id="form-eye-open">
                <path d="M51.062,21.561c-5.759-5.759-13.416-8.931-21.561-8.931S13.7,15.801,7.941,21.561L0,29.501l8.138,8.138c5.759,5.759,13.416,8.931,21.561,8.931s15.802-3.171,21.561-8.931l7.941-7.941L51.062,21.561z M49.845,36.225c-5.381,5.381-12.536,8.345-20.146,8.345s-14.765-2.963-20.146-8.345l-6.724-6.724l6.527-6.527c5.381-5.381,12.536-8.345,20.146-8.345s14.765,2.963,20.146,8.345l6.724,6.724L49.845,36.225z" />
                <path d="M29.572,16.57c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S36.741,16.57,29.572,16.57z M29.572,24.57c-2.757,0-5,2.243-5,5c0,0.552-0.448,1-1,1s-1-0.448-1-1c0-3.86,3.14-7,7-7c0.552,0,1,0.448,1,1S30.125,24.57,29.572,24.57z" />
            </g>
        );
    },
    EyeClosed: () => {
        return (
            <g id="form-eye-closed">
                <path d="M11.285,41.39c0.184,0.146,0.404,0.218,0.623,0.218c0.294,0,0.585-0.129,0.783-0.377c0.344-0.432,0.273-1.061-0.159-1.405c-0.801-0.638-1.577-1.331-2.305-2.06l-7.398-7.398l7.629-7.629c7.334-7.333,18.003-9.836,27.839-6.534c0.523,0.173,1.09-0.107,1.267-0.63c0.175-0.523-0.106-1.091-0.63-1.267c-10.562-3.545-22.016-0.857-29.89,7.016L0,30.368l8.812,8.812C9.593,39.962,10.426,40.705,11.285,41.39z" />
                <path d="M50.237,21.325c-1.348-1.348-2.826-2.564-4.394-3.616c-0.458-0.307-1.081-0.185-1.388,0.273c-0.308,0.458-0.185,1.08,0.273,1.388c1.46,0.979,2.838,2.113,4.094,3.369l7.398,7.398l-7.629,7.629c-7.385,7.385-18.513,9.882-28.352,6.356c-0.52-0.187-1.093,0.084-1.279,0.604c-0.186,0.52,0.084,1.092,0.604,1.279c3.182,1.14,6.49,1.693,9.776,1.693c7.621,0,15.124-2.977,20.665-8.518l9.043-9.043L50.237,21.325z" />
                <path d="M30.539,41.774c-2.153,0-4.251-0.598-6.07-1.73c-0.467-0.29-1.084-0.148-1.377,0.321c-0.292,0.469-0.148,1.085,0.321,1.377c2.135,1.33,4.6,2.032,7.126,2.032c7.444,0,13.5-6.056,13.5-13.5c0-2.685-0.787-5.279-2.275-7.502c-0.308-0.459-0.93-0.582-1.387-0.275c-0.459,0.308-0.582,0.929-0.275,1.387c1.267,1.893,1.937,4.102,1.937,6.39C42.039,36.616,36.88,41.774,30.539,41.774z" />
                <path d="M30.539,18.774c2.065,0,4.089,0.553,5.855,1.6c0.474,0.281,1.088,0.125,1.37-0.351c0.281-0.475,0.125-1.088-0.351-1.37c-2.074-1.229-4.451-1.879-6.875-1.879c-7.444,0-13.5,6.056-13.5,13.5c0,2.084,0.462,4.083,1.374,5.941c0.174,0.354,0.529,0.56,0.899,0.56c0.147,0,0.298-0.033,0.439-0.102c0.496-0.244,0.701-0.843,0.458-1.338c-0.776-1.582-1.17-3.284-1.17-5.06C19.039,23.933,24.198,18.774,30.539,18.774z" />
                <path d="M54.621,5.567c-0.391-0.391-1.023-0.391-1.414,0l-46.5,46.5c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l46.5-46.5C55.012,6.591,55.012,5.958,54.621,5.567z" />
            </g>
        );
    },
};

export function SVGErrorTriangle() {
    return (
        <g strokeWidth="2.9">
            <polygon class="error-triangle" points="15,7 26,25 4,25" strokeLinejoin="round" />
            <path d="M15,12V18.5" />
            <circle class="excl-pt" stroke="none" cx="15" cy="22" r="2" />
        </g>
    );
}

export function SVGInfoIcon() {
    return (
        <g strokeWidth="2.9">
            <circle stroke="transparent" cx="15" cy="15" r="9.9" />
            <circle class="excl-pt" stroke="none" cx="15" cy="12" r="2" />
            <path d="M15,16 V21" />
        </g>
    );
}

export function SVGWarnIcon() {
    return (
        <g>
            <g stroke-width="2.9">
                <circle fill="transparent" cx="15" cy="15" r="9.9" />
                <path d="M15,8.8 V16" />
            </g>
            <g stroke-width="3">
                <circle class="excl-pt" stroke="none" cx="15" cy="19.6" r="2" />
            </g>
        </g>
    );
}
